"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var CustomAdditional = /** @class */ (function (_super) {
    __extends(CustomAdditional, _super);
    function CustomAdditional(props) {
        return _super.call(this, props) || this;
    }
    CustomAdditional.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Container, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 12 },
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement("div", { style: { fontSize: "15px", fontWeight: 300, color: "white" } },
                                "+ ",
                                this.props.additional.value),
                            React.createElement("div", { style: { position: "absolute", display: "flex", right: "0px", fontSize: "15px", fontWeight: 300, color: "white" } }, this.props.additional.price)))))));
    };
    return CustomAdditional;
}(React.Component));
exports.default = CustomAdditional;
//# sourceMappingURL=Additional.js.map